import React from "react"
import { Link, useRouteMatch, useParams } from "react-router-dom"
import { useStoreCardView } from "@usher/pe-client-front-end-lib"
import "./style.sass"
import { CardStatus } from "./CardStatus"

export const CardDetailsHeader = () => {
  const { url } = useRouteMatch()
  const isTransactions = url.indexOf("/transactions") > 0

  const { id } = useParams<{ id: string }>()
  const { cardNumber, balance, currency, status } = useStoreCardView((state) => ({
    cardNumber: state.cardNumber,
    balance: state.card.balance,
    currency: state.card.currency,
    status: state.card.status,
  }))
  return (
    <>
      <div className="main-content_one-card_title card_details_header card_details_balance">
        <span>{cardNumber}</span>
        <div className="card_balance">
          <span>(Balance: &nbsp; </span>
          <span className={balance < 0 ? "text-danger" : "text-success"}>
            {`${balance.toFixed(2)} ${currency} `}
          </span>
          ){status.length > 0 && <CardStatus status={status} />}
        </div>
      </div>
      <div className="main-content_one-card_ul list">
        <li className={!isTransactions ? "active" : ""}>
          <Link to={`/client/cards/${id}`}>Card details</Link>
        </li>
        <li className={isTransactions ? "active" : ""}>
          <Link to={`/client/cards/${id}/transactions`}>Transactions</Link>
        </li>
      </div>
      {/*<div className="main-content_one-card_info">
        CARDS &nbsp;&middot;&nbsp; {cardNumber}
      </div>*/}
    </>
  )
}
